<h2>{{ 'common.phrases.access-denied-for-user-role' | translate | titlecase }}</h2>
